import { useEffect } from "react";
import { useFetcher } from "react-router-dom";

import Spinner from "components/Spinner";
import StatefulLink from "components/StatefulLink";
import TaggedText from "components/TaggedText";
import { PureTooltip } from "components/Tooltip";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";

import { useApiCalls } from "providers/ApiCallsProvider";

import { useUser } from "routes/dataroutes/UserData";

import Messages from "misc/Messages";

import { hasToContactUsBeforeChange } from "utils/planUtils";
import {
  areStripeSubscriptionWritesUnavailable,
  STRIPE_SUBSCRIPTION_WRITES_UNAVAILABLE_MESSAGE
} from "utils/billingCapabilities";


export default function CancelSubscriptionLinks() {
  const { activeSubscription } = useActiveSubscription();
  const user = useUser()!
  const { inProgress: apiCallInProgress } = useApiCalls();
  const unpaidInvoicesFetcher = useFetcher();

  useEffect(() => {
    if ((unpaidInvoicesFetcher.state === "idle") && !unpaidInvoicesFetcher.data) {
      unpaidInvoicesFetcher.load("/billing-data/invoices/not-paid");
    }
  });

  const hasUnpaidInvoices = (unpaidInvoicesFetcher.data?.count !== undefined) && (unpaidInvoicesFetcher.data.count > 0);
  const stripeWritesUnavailable = areStripeSubscriptionWritesUnavailable(activeSubscription);


  if (activeSubscription?.scheduledSubscription?.planSlug === "free") {
    return (
      <PureTooltip
        content={ stripeWritesUnavailable ? STRIPE_SUBSCRIPTION_WRITES_UNAVAILABLE_MESSAGE : undefined }
        clickable
      >
        <StatefulLink
          to="keep-subscription"
          addLocationToState
          className="cursor-pointer"
          hoverClassName="hover:underline"
          disabled={ user.isBlocked || apiCallInProgress || stripeWritesUnavailable }
        >
          Reactivate subscription
        </StatefulLink>
      </PureTooltip>
    );
  } else {
    return (
      <PureTooltip
        content={ stripeWritesUnavailable
          ? STRIPE_SUBSCRIPTION_WRITES_UNAVAILABLE_MESSAGE
          : hasUnpaidInvoices
            ? <TaggedText className="text-wrap" linkStyle="text-white hover:text-lightGray" message={ Messages.cannotCancelBecauseOfUnpaidInvoicesMessage } />
            : undefined
        }
        clickable
      >
        <StatefulLink
          to={ hasToContactUsBeforeChange(activeSubscription?.planSlug)
            ? "cancel-enterprise"
            : "cancel-subscription"
          }
          addLocationToState
          className="cursor-pointer"
          hoverClassName="hover:underline"
          disabled={
            user.hasPaymentIssues
            || user.isBlocked
            || apiCallInProgress
            || unpaidInvoicesFetcher.state === "loading"
            || hasUnpaidInvoices
            || stripeWritesUnavailable
          }
        >
          <div className="flex flex-row gap-x-2">
            <p>Cancel subscription</p>
            { unpaidInvoicesFetcher.state !== "idle" && <Spinner theme="secondary" size={ 16 } className="!text-neutral-500 dark:text-neutral-200" /> }
          </div>
        </StatefulLink>
      </PureTooltip>
    );
  }
};
